import React from "react";
import { Table } from "reactstrap";
import "./employeeLeave.scss";
function LeavesRecord({ leaveData }) {
  return (
    <div>
      <Table borderless responsive className="leaveManagementTable">
        <thead className="tableHeader">
          <tr className="text-center">
            <th className="text-justify">Employee</th>
            <th>Sick Availed</th>
            <th>Sick Planned</th>
            <th>Sick Available</th>
            <th>Annual Availed</th>
            <th>Annual Planned</th>
            <th>Annual Available</th>
            <th>Compensation Availed</th>
            <th>Compensation Available</th>
          </tr>
          <tr className="text-center availedThead"></tr>
        </thead>
        <tbody>
          {leaveData?.map((data, index) => {
            return (
              <tr
                key={index}
                className={`text-center ${index % 2 === 0 ? "row1" : "row2"}`}
              >
                <td className="text-justify text-bold">{data.name}</td>
                <td>{data.sickLeaveAvailed}</td>
                <td>{data.sickPlannedLeave}</td>
                <td>{data.sickLeaveAvailable}</td>
                <td>{data.annualLeaveAvailed}</td>
                <td>{data.annualPlannedLeave}</td>
                <td>{data.annualLeaveAvailable}</td>
                <td>{data.compensationLeaveAvailed}</td>
                <td>{data.compensationLeaveAvailable}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

export default LeavesRecord;
